<template>
	<div class="">
		<div class="d-flex flex-column gap-3 mb-5">
			<calculator_input_value_single @update="setSalary" @brutto="setBrutto" />
			<calculator_output_period @update="setPeriodMonth" />
		</div>

		<h5 class="mb-4 fwc-bold">{{ pll["My net income would be"] }}</h5>
		<calculator_output_currency class="bold-value" />

		<!-- Output summ brutto -->
		<title_value v-if="brutto" class="fwc-bold mt-3" :title="pll['Total net income']" :value="month_period * total_by_month" />
		<!-- Output summ netto -->
		<title_value v-else class="fwc-bold mt-3" :title="pll['Summ']" :value="month_period * salary" />
	</div>
</template>
<script>
import title_value from "./inc/title_value";
import custom_select from "./inc/custom_select";
import calculator_input_value_single from "./inc/calculator_input_value_single";
import calculator_output_currency from "./inc/calculator_output_currency";
import calculator_output_period from "./inc/calculator_output_period";
import currencies from "./mixins/currencies";

export default {
	components: {
		title_value,
		custom_select,
		calculator_input_value_single,
		calculator_output_currency,
		calculator_output_period,
	},
	mixins: [currencies],
	data() {
		return {
			salary: null,
			month_period: null,
			spoiler: false,
			currency_for_calculate_taxes: "EUR",
			brutto: true
		};
	},
	computed: {
		total_by_month() {
			let salary = Number(this.salary);
			if (salary <= 2250) {
				return salary * (79.67 / 100);
			} else if (salary <= 4800) {
				let percentage_of_one = (4800 - salary) / 2550 * (10.52 / 100) + (68.92 / 100);
				return percentage_of_one * salary;
			} else if (salary <= 10000) {
				return salary * (66.25 / 100);
			} else if (salary <= 100000) {
				let percentage_of_one = (100000 - salary) / 90000 * (5.41 / 100) + (54.64 / 100);
				return percentage_of_one * salary;
			} else {
				return salary * (52.05 / 100);
			}
		}
	},
	methods: {
		setBrutto(val) {
			this.brutto = val;
		},
		setPeriodMonth(val) {
			this.month_period = val;
		},
		setSalary(val) {
			this.salary = val;
		},
	},
};
</script>
